module.exports = __webpack_public_path__ + "static/4. XP Method-864833800678dfd2830884c1d0d379e9.png";